const config = {
  // API_URL: 'http://localhost:6010/',
  API_URL: "https://api.socialgames.com/",
  nftBackend: "https://nft.socialgames.com/",
  // nftBackend: 'http://localhost:6015/',
  //SOCKETIO_URL:'https://localhost:4003/',
  // ideaBackend: "http://localhost:8000/",
  ideaBackend: "https://www.socialgames.com/",
  Head_config: {
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  },
};
export default config;